import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getTicketRevenue(year: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/ticketrevenuepermonth`, { year });
  }

  getTicketCounts(year: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/ticketcounts`, { year });
  }

  getOrderCounts(year: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/ordercounts`, { year });
  }

  getMonthlyOrders(year: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/ordercountspermonth`, { year });
  }
}
